import { UnixTimeMs } from './time';

export type TimeSeriesValueTuple = [timestamp: UnixTimeMs, value: number | null];

export function isTimeSeriesValueTuple(data: TimeSeriesValueTuple): data is TimeSeriesValueTuple {
  if (data.length !== 2) return false;
  return true;
}
